import Vue from "vue";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/analytics";
import "firebase/storage";

//add Firebase config here
const config = {
  apiKey: "AIzaSyBiRCDWAYL1GnWho_fQJvBNJtvmAsA2dsI",
  authDomain: "trash-zero.firebaseapp.com",
  projectId: "trash-zero",
  storageBucket: "trash-zero.appspot.com",
  messagingSenderId: "950450321226",
  appId: "1:950450321226:web:15c815c03382a1dc66b3b3",
  measurementId: "G-G99B7EXYP1"
};

firebase.initializeApp(config);

firebase.analytics();
Vue.prototype.$analytics = firebase.analytics();

// firebase utils
const db = firebase.firestore();
const auth = firebase.auth();

export { db, auth, firebase };
